import { hostAppCall } from "../../utils/appFunctions.js"

export const addRecord = () => {
    hostAppCall("goToRecordsOnDevice")
}

export const display = (id: string, cond: boolean) => { 
    const el = document.getElementById(id);
    if (el) el.style.display = cond ? 'block' : 'none' 
}

export const agreeCookie = () => {
    localStorage.setItem("cookieAgreed", "true")
    displayCookiePopUp()
}

export const displayCookiePopUp = () => {
    const cookieAgreed = localStorage.getItem("cookieAgreed") == "true"
    display("cookie-policy", !cookieAgreed)
    display("bottom-soundcorset", cookieAgreed)
}

export const isTopLocation = () => window.location.pathname == "/records"

export const goTuner = () => {
    hostAppCall("goTuner")
}